import React, { Component } from "react";
import "../Drag_Drop/AdminDragDrop.css";
import { Button, Form, Row, Col, Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../../config.json";

export default class ArchiveDragData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      pipelines_Id: sessionStorage.getItem("pipelines_Id"),
      pipelineName: sessionStorage.getItem("pipelineName"),
      userName: sessionStorage.getItem("userName"),
      employeeowner: sessionStorage.getItem("employeeowner"),
      data: [],
      columns: [],
      draggedItem: null,
      draggedItemType: null,
      sourceColumnId: null,
      newTaskInputs: {},
      selectedTask: null,
      newTask: {
        stagename: "",
        stageOrder: "",
        ittaskstable_Id: "",
        projectid: "",
        projectName: "",
        userStory: "",
        taskName: "",
        taskDescription: "",
        assignedTo: "",
        estimatedTaskTime: "",
        estimatedHours: "",
        estimatedMinutes: "",
        actualTaskTime: "",
        taskStartTime: "",
        taskEndTime: "",
        taskReviewStartTime: "",
        taskReviewEndTime: "",
        dependencyTaskID: "",
        hours: "00",
        minutes: "00",
      },
      employees: [],
      leadstages: [],
      ittaskstable: [],
      itprojectstable: [],
      userstoriestable: [],
      filteredUserStories: [],
      filteredDependencyTasks: [],
      selectedProjectid: [],
      selectedUserStory: "",
      selectedProjectName: "",
      filteredData: null,
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      isEditingView: false,
      bulkAction: "",
      assignToUsers: [],
      setStage: [],
      selectedTasks: [],
      activeTab: "Request1",
      taskmovementhistorytable_Id: "",
      taskID: "",
      movedFromStage: "",
      movedToStage: "",
      movedBy: "",
      movedAt: "",
      timeInStage: "",
      taskmovement: [],
      tasknotes_Id: "",
      taskid: "",
      taskNotes: "",
      tasknotes: [],
      selectedMonthLabel: "Filter by Month",
      selectedMonth: null,
      selectedYear: null,
    };
  }
  handleStageCheckboxChange = (e, column) => {
    const { selectedTasks } = this.state;
    const taskIds = column.tasks.map((task) => task.ittaskstable_Id);
    if (e.target.checked) {
      const updatedSelection = [
        ...selectedTasks,
        ...taskIds.filter((id) => !selectedTasks.includes(id)),
      ];
      this.setState({ selectedTasks: updatedSelection });
    } else {
      const updatedSelection = selectedTasks.filter(
        (id) => !taskIds.includes(id)
      );
      this.setState({ selectedTasks: updatedSelection });
    }
  };
  handleTaskCheckboxChange = (e, taskId) => {
    const { selectedTasks } = this.state;
    if (e.target.checked) {
      this.setState({ selectedTasks: [...selectedTasks, taskId] });
    } else {
      this.setState({
        selectedTasks: selectedTasks.filter((id) => id !== taskId),
      });
    }
  };
  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.tasknotes.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  handleBulkActionChange = (e) => {
    this.setState({
      bulkAction: e.target.value,
      assignToUsers: [],
    });
  };
  handleStageActionChange = (e) => {
    this.setState({
      bulkAction: e.target.value,
      setStage: [],
    });
  };
  handleMultiSelectChange = (e) => {
    const selectedOptions = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    this.setState({ assignToUsers: selectedOptions });
  };
  handlestageMultiSelectChange = (e) => {
    const selectedOptions = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    this.setState({ setStage: selectedOptions });
  };
  //stage submit event
  handleSetstageSubmit = () => {
    const { selectedTasks, setStage } = this.state;

    if (setStage.length === 0) {
      this.showToast("Please select a stage", "error");
      return;
    }
    if (selectedTasks.length === 0) {
      this.showToast("Please select at least one task", "error");
      return;
    }
    const selectedStageId = setStage[0];
    this.showToast("Updating tasks...", "info");
    let successCount = 0;
    const updatePromises = selectedTasks.map((taskId) => {
      const formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("ittaskstable_Id", taskId);
      formData.append("stagename", selectedStageId);
      return fetch(configData.api_url + "C_Ittaskstable/update", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            successCount++;
            return { success: true, taskId };
          } else {
            return { success: false, taskId, message: data.message };
          }
        });
    });
    Promise.all(updatePromises).then((results) => {
      if (successCount === selectedTasks.length) {
        this.showToast(`Successfully updated ${successCount} tasks`, "success");
      } else {
        this.showToast(
          `Updated ${successCount} out of ${selectedTasks.length} tasks`,
          "warning"
        );
      }
      this.IttaskstablefetchHandler();
      this.setState({ selectedTasks: [], setStage: [], bulkAction: "" });
    });
  };

  // assign submit event
  handleAssignSubmit = () => {
    const { selectedTasks, assignToUsers } = this.state;

    if (assignToUsers.length === 0) {
      this.showToast("Please select a user to assign", "error");
      return;
    }

    if (selectedTasks.length === 0) {
      this.showToast("Please select at least one task", "error");
      return;
    }

    const selectedUserId = assignToUsers[0]; // Get the first selected user ID
    this.showToast("Updating tasks...", "info");

    let successCount = 0;
    const updatePromises = selectedTasks.map((taskId) => {
      const formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("ittaskstable_Id", taskId);
      formData.append("assignedTo", selectedUserId);

      return fetch(configData.api_url + "C_Ittaskstable/update", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            successCount++;
            return { success: true, taskId };
          } else {
            return { success: false, taskId, message: data.message };
          }
        });
    });
    Promise.all(updatePromises).then((results) => {
      if (successCount === selectedTasks.length) {
        this.showToast(
          `Successfully assigned ${successCount} tasks`,
          "success"
        );
      } else {
        this.showToast(
          `Assigned ${successCount} out of ${selectedTasks.length} tasks`,
          "warning"
        );
      }
      this.IttaskstablefetchHandler();
      this.setState({ selectedTasks: [], assignToUsers: [], bulkAction: "" });
    });
  };
  //it tasks delete
  handleITDelete = (row, index) => {
    const { selectedTasks, sId, uId } = this.state;
    if (selectedTasks.length === 0) {
      this.showToast("No tasks selected", "error");
      return;
    }
    Promise.all(
      selectedTasks.map((taskId) => {
        const formData = new FormData();
        formData.append("sId", sId);
        formData.append("uId", uId);
        formData.append("ittaskstable_Id", taskId);

        return fetch(configData.api_url + "C_Ittaskstable/delete", {
          method: "POST",
          mode: "cors",
          body: formData,
        }).then((res) => res.json());
      })
    ).then((results) => {
      const successCount = results.filter((r) => r.status === "success").length;
      this.showToast(`${successCount} task(s) deleted successfully`, "success");
      this.setState({ selectedTasks: [] });
      this.IttaskstablefetchHandler();
    });
  };
  //task edit event
  IttaskstableviewHandler = (taskId) => {
    const task = this.state.ittaskstable.find(
      (item) => item.ittaskstable_Id === taskId
    );

    if (!task) {
      this.showToast("Task not found in existing data", "error");
      return;
    }

    // Find all task movements with the same taskID
    const allTaskMovements = this.state.taskmovement.filter(
      (item) => item.taskID === taskId
    );

    // Sort by movedAt descending (latest first) and get the latest one
    const latestTaskMovement =
      allTaskMovements.length > 0
        ? allTaskMovements.sort(
            (a, b) => new Date(b.movedAt) - new Date(a.movedAt)
          )[0]
        : null;

    // Base state object with task data
    const baseState = {
      isEditingView: true,
      isEditing: false,
      show: true,
      ittaskstable_Id: task.ittaskstable_Id,
      projectid: task.projectid,
      projectName: task.projectName,
      userStory: task.userStory,
      taskName: task.taskName,
      taskDescription: task.taskDescription,
      assignedTo: task.assignedTo,
      estimatedTaskTime: task.estimatedTaskTime,
      actualTaskTime: task.actualTaskTime,
      taskStartTime: task.taskStartTime,
      taskEndTime: task.taskEndTime,
      taskReviewStartTime: task.taskReviewStartTime,
      taskReviewEndTime: task.taskReviewEndTime,
      dependencyTaskID: task.dependencyTaskID,
      stagename: task.stagename,
      colorCode: task.colorCode || "",
    };

    // Add task movement data if it exists
    if (latestTaskMovement) {
      baseState.taskmovementhistorytable_Id =
        latestTaskMovement.taskmovementhistorytable_Id;
      baseState.taskID = latestTaskMovement.taskID;
      baseState.movedFromStage = latestTaskMovement.movedFromStage;
      baseState.movedToStage = latestTaskMovement.movedToStage;
      baseState.movedBy = latestTaskMovement.movedBy;
      baseState.movedAt = latestTaskMovement.movedAt;
      baseState.timeInStage = latestTaskMovement.timeInStage;
    } else {
      // Set default values for task movement fields when no movement data exists
      baseState.taskmovementhistorytable_Id = null;
      baseState.taskID = taskId;
      baseState.movedFromStage = null;
      baseState.movedToStage = null;
      baseState.movedBy = null;
      baseState.movedAt = null;
      baseState.timeInStage = null;
    }

    this.setState(baseState);
  };
  //month filter
  filterTasksByMonth = (tasks, monthType) => {
    const now = new Date();
    let month, year;

    if (monthType === "thisMonth") {
      month = now.getMonth();
      year = now.getFullYear();
    } else if (monthType === "lastMonth") {
      if (now.getMonth() === 0) {
        month = 11;
        year = now.getFullYear() - 1;
      } else {
        month = now.getMonth() - 1;
        year = now.getFullYear();
      }
    }

    return tasks.filter((task) => {
      const createdDate = new Date(task.createdOn);
      return (
        createdDate.getMonth() === month && createdDate.getFullYear() === year
      );
    });
  };
  updateFilteredTasks = (filteredTasks) => {
    const stageCounts = {};
    filteredTasks.forEach((task) => {
      const stage = task.stagename;
      stageCounts[stage] = (stageCounts[stage] || 0) + 1;
    });

    const { columns } = this.state;
    const newColumns = columns.map((col) => ({
      ...col,
      tasks: [],
      taskCount: stageCounts[col.id] || 0,
    }));

    filteredTasks.forEach((task) => {
      const targetColIndex = newColumns.findIndex(
        (col) => col.id === task.stagename
      );
      if (targetColIndex !== -1) {
        newColumns[targetColIndex].tasks.push(task);
      }
    });

    this.setState({
      columns: newColumns,
    });
  };
  filterByCustomMonth = (month, year) => {
    const filtered = this.state.ittaskstable.filter((task) => {
      const createdDate = new Date(task.createdOn);
      return (
        createdDate.getMonth() === month && createdDate.getFullYear() === year
      );
    });

    this.updateFilteredTasks(filtered);
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };
  handleResetFilter = () => {
    this.setState(
      {
        itprojectstable_Id: null,
        employees_Id: null,
        selectedMonthLabel: "Select Month",
        selectedMonth: null,
        selectedYear: null,
      },
      () => {
        this.IttaskstablefetchHandler();
        this.updateFilteredTasks(this.state.ittaskstable);
      }
    );
  };
  IttaskstablefetchHandler = () => {
    const { sId, uId, itprojectstable_Id, employees_Id } = this.state;
    const formData = new FormData();
    formData.append("sId", sId);
    formData.append("uId", uId);
    //formData.append("user_id", uId);
    let url = configData.api_url + "C_Ittaskstable/getUsertasks";
    if (itprojectstable_Id !== null && itprojectstable_Id !== undefined) {
      formData.append("projectId", itprojectstable_Id);
      url = configData.api_url + "C_Ittaskstable/getUsertasksByProject";
    } else if (employees_Id !== null && employees_Id !== undefined) {
      formData.append("uId", employees_Id);
      url = configData.api_url + "C_Ittaskstable/getUserTasksByUserId";
    }
    fetch(url, {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const fetchedTasks = data.tasks;
          // Step 1: calculate stage-wise counts
          const stageCounts = {};
          fetchedTasks.forEach((task) => {
            const stage = task.stagename;
            stageCounts[stage] = (stageCounts[stage] || 0) + 1;
          });
          const { columns } = this.state;
          const newColumns = columns.map((col) => ({
            ...col,
            tasks: [],
            taskCount: stageCounts[col.id] || 0,
          }));

          fetchedTasks.forEach((task) => {
            const targetColIndex = newColumns.findIndex(
              (col) => col.id === task.stagename
            );
            if (targetColIndex !== -1) {
              newColumns[targetColIndex].tasks.push(task);
            }
          });

          // Step 3: Update state
          this.setState({
            ittaskstable: fetchedTasks,
            columns: newColumns,
          });
        }
      });
  };
  itprojectstablefetchHandler = () => {
    fetch(configData.api_url + "C_Itprojectstable/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ itprojectstable: data.list });
        }
      });
  };
  employeesfetchHandler = () => {
    var formData = new FormData();
    // formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Ittaskstable/getTeamMembers", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.team_ids });
        }
      });
  };
  LeadstagesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Leadstages/list", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ leadstages: data.list });
        }
      });
  };
  fetchLeadStages = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("pipelines_Id", this.state.pipelines_Id);
    fetch(configData.api_url + "C_Leadstages/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const sorted = data.list
            .filter((item) => item.pipelineId === this.state.pipelines_Id)
            .sort((a, b) => parseInt(a.stageOrder) - parseInt(b.stageOrder));
          const columns = sorted.map((stage) => ({
            id: stage.leadstages_Id,
            title: stage.stageName,
            tasks: [],
            stageOrder: parseInt(stage.stageOrder),
          }));

          this.setState({ columns });
        }
      });
  };
  componentDidMount() {
    // this.fetchPipelineDetails();
    this.fetchLeadStages();
    this.itprojectstablefetchHandler();
    this.employeesfetchHandler();
    this.LeadstagesfetchHandler();
    this.IttaskstablefetchHandler();
  }
  // New task form input change
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      newTask: { ...prevState.newTask, [name]: value },
    }));
  };

  handleDragStart = (e, item, type, stagename) => {
    this.setState({
      draggedItem: item,
      draggedItemType: type,
      sourceColumnId: stagename,
    });
    e.dataTransfer.setData(
      "text/plain",
      JSON.stringify({ item, type, sourceColumnId: stagename })
    );
    e.target.style.opacity = "0.5";
  };

  handleDragEnd = (e) => {
    e.target.style.opacity = "1";
    this.setState({
      draggedItem: null,
      draggedItemType: null,
      sourceColumnId: null,
    });
  };

  handleDragOver = (e) => {
    e.preventDefault();
  };

  handleDrop = (e, targetColumnId) => {
    e.preventDefault();
    const { draggedItem, draggedItemType, columns } = this.state;
    if (!draggedItem) return;
    let updatedColumns = [...columns];
    if (draggedItemType === "column") {
      const draggedIndex = updatedColumns.findIndex(
        (col) => col.id === draggedItem.id
      );
      const targetIndex = updatedColumns.findIndex(
        (col) => col.id === targetColumnId
      );

      if (draggedIndex !== -1 && targetIndex !== -1) {
        const [moved] = updatedColumns.splice(draggedIndex, 1);
        updatedColumns.splice(targetIndex, 0, moved);

        // Reassign stageOrder based on new order
        updatedColumns = updatedColumns.map((col, index) => ({
          ...col,
          stageOrder: index + 1, // starting from 1
        }));

        this.setState({ columns: updatedColumns }, () => {
          this.updateStageOrderOnServer(updatedColumns); // Call API to update order
        });
      }
    }

    this.setState({ draggedItem: null, draggedItemType: null });
  };

  deleteTask = (stagename, taskId) => {
    this.setState((prevState) => {
      const updatedColumns = prevState.columns.map((col) => {
        if (col.id === stagename && col.tasks) {
          return {
            ...col,
            tasks: col.tasks.filter((task) => task.id !== taskId),
          };
        }
        return col;
      });
      return { columns: updatedColumns };
    });
  };
  updateStageOrderOnServer = (columns) => {
    const { sId, uId } = this.state;

    columns.forEach((col) => {
      const formData = new FormData();
      formData.append("sId", sId);
      formData.append("uId", uId);
      formData.append("leadstages_Id", col.id);
      formData.append("stageOrder", col.stageOrder); // new order

      fetch(configData.api_url + "C_Leadstages/update", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            this.showToast(data.message, data.status);
          }
        });
    });
  };
  handleCardDragStart = (task, sourceColumnId) => {
    this.setState({
      draggedItem: task,
      draggedItemType: "card",
      sourceColumnId,
    });
  };
  handleCardDragOver = (e) => {
    e.preventDefault(); // Allow drop
  };
  // Modify handleCardDrop to refresh tasks after the update
  handleCardDrop = (targetColumnId) => {
    const { draggedItem, sourceColumnId, columns, draggedItemType } =
      this.state;
    if (draggedItem && draggedItemType === "card") {
      const updatedColumns = columns.map((col) => {
        if (col.id === sourceColumnId) {
          return {
            ...col,
            tasks: col.tasks.filter((task) => task.id !== draggedItem.id),
          };
        } else if (col.id === targetColumnId) {
          return {
            ...col,
            tasks: [
              ...col.tasks,
              { ...draggedItem, stagename: targetColumnId },
            ],
          };
        }
        return col;
      });

      // Call the API to update the task's stage on the server
      const taskId = draggedItem.ittaskstable_Id || draggedItem.id;
      const movedFromStage = sourceColumnId;
      const movedToStage = targetColumnId;
      const movedBy = this.state.uId || "system";
      const movedAt = new Date().toISOString();
      this.setState(
        {
          columns: updatedColumns,
          draggedItem: null,
          draggedItemType: null,
          sourceColumnId: null,
          taskID: taskId,
          movedFromStage,
          movedToStage,
          movedBy,
          movedAt,
          timeInStage: "",
        },
        () => {
          // Update the task on the server
          this.updateTaskStage(taskId, targetColumnId, () => {
            // After the API call completes, refresh all tasks to ensure sync with server
            this.IttaskstablefetchHandler();
            this.TaskmovementhistorytablesubmitHandler();
          });
        }
      );
    }
  };
  // Update the updateTaskStage method to accept a callback
  updateTaskStage = (taskId, newStageId, callback) => {
    const { sId, uId } = this.state;
    const formData = new FormData();
    formData.append("sId", sId);
    formData.append("uId", uId);
    formData.append("ittaskstable_Id", taskId);
    formData.append("stagename", newStageId);
    // Include any other required fields for your API

    fetch(configData.api_url + "C_Ittaskstable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, data.status);
        } else {
          this.showToast(
            data.message || "Failed to update task stage",
            "error"
          );
        }

        // Call the callback function if provided
        if (typeof callback === "function") {
          callback();
        }
      })
      .catch((error) => {
        this.showToast("Failed to update task stage", "error");
        // Call the callback function even on error
        if (typeof callback === "function") {
          callback();
        }
      });
  };
  handleprojectidChange = (e) => {
    const selectedProjectId = e.target.value;

    const selectedProject = this.state.itprojectstable.find(
      (project) => project.itprojectstable_Id === selectedProjectId
    );

    const selectedProjectName = selectedProject?.projectName || "";

    const filteredUserStories = this.state.userstoriestable.filter(
      (story) => story.projectName === selectedProjectName
    );

    const filteredDependencyTasks = this.state.ittaskstable.filter(
      (task) => task.projectName === selectedProjectName
    );

    const filteredStages = this.state.leadstages.filter(
      (stage) => stage.projectName === selectedProjectName
    );

    this.setState({
      projectid: selectedProjectId,
      projectName: selectedProjectName,
      colorCode: selectedProject?.colorCode || "",
      filteredUserStories,
      filteredDependencyTasks,
      filteredStages,
    });
  };
  handleprojectNameChange = (e) => {
    e.preventDefault();
    const selectedProjectName = e.target.value;
    //const fieldValue = e.target.value;
    const selectedProject = this.state.itprojectstable.find(
      (project) => project.projectName === selectedProjectName
    );
    const selectedProjectId = selectedProject?.itprojectstable_Id || "";
    const filteredUserStories = this.state.userstoriestable.filter(
      (story) => story.projectName === selectedProjectName
    );

    const filteredDependencyTasks = this.state.ittaskstable.filter(
      (task) => task.projectName === selectedProjectName
    );
    this.setState({
      projectid: selectedProjectId,
      projectName: selectedProjectName,
      selectedProjectName, // 👈 IMPORTANT
      selectedUserStory: "", // reset story selection
      colorCode: selectedProject?.colorCode,
      filteredUserStories,
      filteredDependencyTasks,
    });
  };
  IttaskstableupdateHandler = (e) => {
    const {
      sId,
      uId,
      stagename,
      assignedTo,
      projectName,
      userStory,
      taskName,
      taskDescription,
      dependencyTaskID,
      ittaskstable_Id,
      colorCode,
    } = this.state;
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", sId);
    formData.append("uId", uId);
    formData.append("ittaskstable_Id", ittaskstable_Id);
    formData.append("stagename", stagename);
    formData.append("colorCode", colorCode);
    formData.append("assignedTo", assignedTo);
    formData.append("projectName", projectName);
    formData.append("userStory", userStory);
    formData.append("taskName", taskName);
    formData.append("taskDescription", taskDescription);
    formData.append("dependencyTaskID", dependencyTaskID);
    formData.append("estimatedTaskTime", "");
    formData.append("actualTaskTime", "");
    formData.append("taskStartTime", "");
    formData.append("taskEndTime", "");
    formData.append("taskReviewStartTime", "");
    formData.append("taskReviewEndTime", "");
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");
    //***tableData1
    fetch(configData.api_url + "C_Ittaskstable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IttaskstablefetchHandler();
          this.handleOffcanvasClose();
        }
      });
  };
  TaskmovementhistorytablesubmitHandler = (e) => {
    if (e) e.preventDefault(); // Allow both manual call and form submission

    const formData = new FormData();
    formData.append("sId", this.state.sId); // Adjust as needed
    formData.append("uId", this.state.uId);
    formData.append("taskID", this.state.taskID);
    formData.append("movedFromStage", this.state.movedFromStage);
    formData.append("movedToStage", this.state.movedToStage);
    formData.append("movedBy", this.state.movedBy);
    formData.append("movedAt", this.state.movedAt);
    formData.append("timeInStage", this.state.timeInStage || "");
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");

    fetch(configData.api_url + "C_Taskmovementhistorytable/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.TaskmovementhistorytablefetchHandler();
          this.setState({
            taskID: "",
            movedFromStage: "",
            movedToStage: "",
            movedBy: "",
            movedAt: "",
            timeInStage: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
          });
        }
      });
  };
  render() {
    const { bulkAction } = this.state;
    const pipelineName = sessionStorage.getItem("pipelineName");
    return (
      <div className="mx-auto p-4">
        <h3>Archive Drag Data</h3>
        <Row>
          <div className="col-6">
            <p className="p-1">
              <b> Name: </b>
              {pipelineName}
            </p>
          </div>
          <div className="col-6 text-end">
            <Button
              variant="success"
              className="mb-4 mt-1 rounded-0"
              onClick={() => this.handletwoShowOffcanvas()}
            >
              + Add New Task
            </Button>
          </div>
        </Row>
        <div>
          {this.state.employees.length > 0 && (
            <Row className="align-items-end">
              <Col lg="1">
                <Dropdown className="d-inline-block">
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    className="mb-2 rounded-0"
                  >
                    Filter
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="main-dropdown">
                    <div className="dropdown-submenu">
                      <Dropdown.Item className="submenu-toggle">
                        By user
                      </Dropdown.Item>
                      <ul className="dropdown-menu">
                        <li>
                          <Dropdown.Item
                            key="all"
                            onClick={() => {
                              this.setState({ employees_Id: null }, () =>
                                this.IttaskstablefetchHandler()
                              );
                            }}
                          >
                            Users List
                          </Dropdown.Item>
                          {this.state.employees
                            .slice()
                            .sort((a, b) => {
                              const nameA = a.fName.toLowerCase();
                              const nameB = b.fName.toLowerCase();
                              if (nameA < nameB) return -1;
                              if (nameA > nameB) return 1;
                              return 0;
                            })
                            .map((api, index) => (
                              <Dropdown.Item
                                key={index}
                                onClick={() => {
                                  this.setState(
                                    {
                                      employees_Id: api.employees_Id,
                                    },
                                    () => this.IttaskstablefetchHandler()
                                  );
                                }}
                              >
                                {api.fName}&nbsp;{api.lName}
                              </Dropdown.Item>
                            ))}
                          {/* {this.state.employees.map((api, index, idx) => (
                                    <Dropdown.Item
                                      className="submenu-toggle"
                                      key={index}
                                      value={api.employees_Id}
                                    >
                                      {api.fName}&nbsp;{api.lName}
                                    </Dropdown.Item>
                                  ))} */}
                        </li>
                      </ul>
                    </div>
                    <div className="dropdown-submenu">
                      <Dropdown.Item className="submenu-toggle">
                        By Project
                      </Dropdown.Item>
                      <ul className="dropdown-menu">
                        <li>
                          <Dropdown.Item
                            key="all"
                            onClick={() => {
                              this.setState({ itprojectstable_Id: null }, () =>
                                this.IttaskstablefetchHandler()
                              );
                            }}
                          >
                            Project List
                          </Dropdown.Item>

                          {this.state.itprojectstable
                            .slice()
                            .sort((a, b) => {
                              const nameA = a.projectName.toLowerCase();
                              const nameB = b.projectName.toLowerCase();
                              if (nameA < nameB) return -1;
                              if (nameA > nameB) return 1;
                              return 0;
                            })
                            .map((api, index) => (
                              <Dropdown.Item
                                key={index}
                                onClick={() => {
                                  this.setState(
                                    {
                                      itprojectstable_Id:
                                        api.itprojectstable_Id,
                                    },
                                    () => this.IttaskstablefetchHandler()
                                  );
                                }}
                              >
                                {api.projectName}
                              </Dropdown.Item>
                            ))}
                        </li>
                      </ul>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col lg="2">
                <Form.Group className="form-group">
                  <Form.Select
                    name="bulkAction"
                    value={bulkAction}
                    onChange={this.handleBulkActionChange}
                    className="form-control"
                    // style={{ height: "47px" }}
                  >
                    <option value="">Bulk Actions</option>
                    <option value="Assignto">Assign To</option>
                    <option value="setstage">Set Stage</option>
                    <option value="delete">Delete</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              {this.state.bulkAction === "Assignto" && (
                <Col lg="2">
                  <Form.Group className="form-group">
                    <Form.Select
                      name="assignToUsers"
                      value={this.state.assignToUsers}
                      onChange={this.handleMultiSelectChange}
                    >
                      <option value="">Assign Members</option>
                      {this.state.employees
                        .slice()
                        .sort((a, b) => {
                          const nameA = a.fName.toLowerCase();
                          const nameB = b.fName.toLowerCase();
                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;
                          return 0;
                        })
                        .map((api, index, idx) => (
                          <option key={index} value={api.employees_Id}>
                            {api.fName}&nbsp;{api.lName}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              )}
              {this.state.bulkAction === "setstage" && (
                <Col lg="2">
                  <Form.Group className="form-group">
                    <Form.Select
                      name="setStage"
                      value={this.state.setStage}
                      onChange={this.handlestageMultiSelectChange}
                    >
                      <option value="">Stages</option>
                      {this.state.leadstages
                        .slice()
                        .sort((a, b) => {
                          const nameA = a.stageName.toLowerCase();
                          const nameB = b.stageName.toLowerCase();
                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;
                          return 0;
                        })
                        .map((api, index) => (
                          <option key={index} value={api.leadstages_Id}>
                            {api.stageName}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              )}
              {this.state.bulkAction === "setstage" && (
                <Col lg="1">
                  <Button
                    variant="primary"
                    className="mt-1 mb-2 rounded-0"
                    onClick={this.handleSetstageSubmit}
                  >
                    Submit
                  </Button>
                </Col>
              )}
              {this.state.bulkAction === "Assignto" && (
                <Col lg="1">
                  <Button
                    variant="primary"
                    className="mt-1 mb-2 rounded-0"
                    onClick={this.handleAssignSubmit}
                  >
                    Submit
                  </Button>
                </Col>
              )}
              {this.state.bulkAction === "delete" && (
                <Col lg="1">
                  <Button
                    variant="primary"
                    className="mt-1 mb-2 rounded-0"
                    onClick={this.handleITDelete}
                  >
                    Submit
                  </Button>
                </Col>
              )}
              <Col lg="1">
                <Button
                  variant="secondary"
                  className="mt-1 mb-2 rounded-0"
                  onClick={this.handleResetFilter}
                >
                  Reset
                </Button>
              </Col>
              <Col>
                <Dropdown>
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    className="mb-2 rounded-0"
                  >
                    Filter by Month
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {[
                      { month: 0, label: "January" },
                      { month: 1, label: "February" },
                      { month: 2, label: "March" },
                      { month: 3, label: "April" },
                      { month: 4, label: "May" },
                      { month: 5, label: "June" },
                      { month: 6, label: "July" },
                      { month: 7, label: "August" },
                      { month: 8, label: "September" },
                      { month: 9, label: "October" },
                      { month: 10, label: "November" },
                      { month: 11, label: "December" },
                    ].map((item) => (
                      <Dropdown.Item
                        key={item.month}
                        onClick={() => {
                          this.filterByCustomMonth(item.month, 2025); // Example for year 2025
                        }}
                      >
                        {item.label} 2025
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
          )}
        </div>
        <div>
          {(() => {
            const stage99Column = this.state.columns.find(
              (col) => col.stageOrder === 99
            );
            const isDraggingCard = this.state.draggedItemType === "card";

            if (
              stage99Column &&
              (isDraggingCard || stage99Column.tasks.length > 0)
              /* stage99Column &&
              isDraggingCard */
            ) {
              return (
                <div
                  className="stage99-containersample"
                  onDragOver={this.handleCardDragOver}
                  onDrop={() => this.handleCardDrop(stage99Column.id)}
                  style={{
                    border: "2px dashed #aaa",
                    marginTop: "20px",
                    padding: "10px",
                    background: "#f9f9f9",
                    borderRadius: "8px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <strong>{stage99Column.stageName}</strong>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    {stage99Column.tasks.map((task) => (
                      <div
                        key={task.id}
                        draggable
                        onDragStart={() =>
                          this.handleCardDragStart(task, stage99Column.id)
                        }
                        onDragEnd={this.handleDragEnd}
                        className="kanban-card"
                        style={{
                          width: "15%",
                          cursor: "grab",
                          userSelect: "none",
                          marginBottom: "10px",
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          padding: "8px",
                          borderRadius: "4px",
                          background: "#fff",
                        }}
                      >
                        <ul
                          className="list-group list-group-light"
                          style={{
                            borderTop: `3px solid ${
                              task.colorCode || "#3ca8e8"
                            }`,
                          }}
                        >
                          <li className="list-group-item d-flex justify-content-between align-items-center p-1">
                            {/* <p>{task.ittaskstable_Id || task.id}</p> */}
                            <span style={{ fontSize: "12px" }}>
                              <p>Task Id : {task.ittaskstable_Id}</p>
                            </span>
                            <span className="badge badge-primary ">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                // value=""
                                // onClick={(e) => e.stopPropagation()}
                                value={task.ittaskstable_Id}
                                aria-hidden="true"
                                onChange={(e) =>
                                  this.handleTaskCheckboxChange(
                                    e,
                                    task.ittaskstable_Id
                                  )
                                }
                                checked={this.state.selectedTasks.includes(
                                  task.ittaskstable_Id
                                )}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center p-1">
                            {/* <span>{task.assignedTo}</span> */}
                            <div
                              style={{
                                color: `${task.colorCode || "#3ca8e8"}`,
                              }}
                            >
                              {task.projectName}
                            </div>
                          </li>
                          <li className="list-group-item align-items-end  p-1">
                            {task.taskName}
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center p-1">
                            {/* {task.stagename} */}
                            <span style={{ fontSize: "11px" }}>
                              {(() => {
                                const emp = this.state.employees.find(
                                  (e) =>
                                    String(e.employees_Id) ===
                                    String(task.assignedTo)
                                );
                                return emp ? `${emp.fName}` : "N/A";
                              })()}
                            </span>
                            <span className="badge badge-primary">
                              <i
                                className="bi bi-eye-fill"
                                aria-hidden="true"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.IttaskstableviewHandler(
                                    task.ittaskstable_Id
                                  );
                                  this.setState({ isEditingView: true });
                                }}
                              ></i>
                              <i
                                className="bi bi-pencil"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.IttaskstableeditHandler(
                                    task.ittaskstable_Id
                                  );
                                  this.setState({ isEditing: true });
                                }}
                                aria-hidden="true"
                                // style={{ paddingRight: "8px" }}
                              ></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }
            return null;
          })()}
        </div>
      </div>
    );
  }
}
